import { RadioGroup, useFormState } from 'informed';
import PropTypes from 'prop-types';
import React from 'react';

import { CardGridTemplate } from 'Templates';

const CardSelectGroup = ({ children, field, ...rest }) => {
  const formState = useFormState();
  const fieldValue = formState.values[field];
  const childrenWithFieldValue = React.Children.map(children, (child) =>
    React.cloneElement(child, {
      fieldValue,
    }),
  );
  return (
    <RadioGroup field={field} {...rest}>
      <CardGridTemplate>{childrenWithFieldValue}</CardGridTemplate>
    </RadioGroup>
  );
};

CardSelectGroup.propTypes = {
  children: PropTypes.node.isRequired,
  field: PropTypes.string.isRequired,
};

export default CardSelectGroup;
